// App Configuration
// Update these values with your actual details

// Dynamic API base URL — same logic as api.js:
//   1. REACT_APP_API_BASE_URL env var
//   2. Hardcoded production backend URL (frontend & backend are on different hosts)
//   3. LAN IP (a tester on the same Wi-Fi opening this PC's local IPv4) — talk
//      to the backend on that same IP instead of the production host
//   4. Fallback to localhost for dev
const LAN_HOSTNAME_PATTERN = /^(10\.\d{1,3}\.\d{1,3}\.\d{1,3}|192\.168\.\d{1,3}\.\d{1,3}|172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3})$/;

const getBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_BASE_URL;
  if (envUrl) return envUrl;
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // LOCAL: matches backend .env PORT=5001
    return 'http://localhost:5001/api';
  }
  if (LAN_HOSTNAME_PATTERN.test(hostname)) {
    return `http://${hostname}:5001/api`;
  }
  // Frontend is hosted on dev.televalley.in but the backend API is on
  // back.televalley.in, so we cannot derive the API URL from
  // window.location.origin — use the known backend host instead.
  return 'https://back.televalley.in/api';
  // return 'https://devback.televalley.in/api';
};

export const APP_CONFIG = {
  // API Configuration
  API_BASE_URL: getBaseUrl(),

  // Calendly Configuration
  // Your Calendly scheduling link for 30-minute demo calls
  CALENDLY_URL: 'https://calendly.com/growthvalley05/30min',

  // Company Info
  COMPANY_NAME: 'TeleValley',
  COMPANY_EMAIL: 'contact@TeleValley.io',

  // Social Links
  WHATSAPP_NUMBER: '919876543210', // Without + sign
  WHATSAPP_MESSAGE: "Hi! I'm interested in TeleValley. Can you tell me more?",

  // WhatsApp Community invite link (shown in admin sidebar)
  // Replace with your actual WhatsApp Community invite link
  COMMUNITY_WHATSAPP_URL: 'https://chat.whatsapp.com/CuH0uepKoZUFYqzSIhVSMq?s=cl&p=a&ilr=1',
};